import React from 'react'


export default function RefundPolicy() {
  const bannerstyle = {
    margin: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
    paddingBottom: '3%'
  }
  
  return (
    <div>
      
        <section className="banner" style={bannerstyle}>
           <div className="container-fluid">
               <div className="row">
                   <div className="col-md-12 p-0">
                       <div className="sub-banner">
                          <img src="/assets/img/banner-refund-policy.jpg" className="d-block w-100" alt="..." />
                          
  
                       </div>
                   </div>
               </div>
           </div>
           <div className="container aboutHead">
                <div className="row">
                    <div className="col-md-12">
                         <h1>Refund Policy</h1>
                    </div>
                </div>
           </div>
       </section>

<section className="privacy"> 
      <div className="container">
        <div className='row'>
          <div className='col-md-12 my-4'>
            
  <p>
    Welcome to <strong>Unlock Destinations</strong>. We strive to provide seamless and memorable travel experiences for our customers.<br />Please read our refund policy carefully before making a booking.
  </p>

  <h2>Flight Cancellation &amp; Refunds</h2>

  <ul>
    <li>
      <p>Flight tickets are subject to airline cancellation and refund rules.</p>
    </li>
    <li>
      <p>Some promotional or discounted fares may be completely non-refundable.</p>
    </li>
    <li>
      <p>Refund timelines for flights depend on the respective airline policies.</p>
    </li>
  </ul>

  <h2>Hotel &amp; Resort Refunds</h2>

  <ul>
    <li>
      <p>Hotel cancellations are governed by the hotel's own cancellation policy.</p>
    </li>
    <li>
      <p>Peak season, festival dates, honeymoon packages, and luxury stays may have stricter cancellation rules.</p>
    </li>
  </ul>

   <h2>Refund Processing Timeline</h2>


<ul>
  <li>
    <p>Approved refunds will be processed within 7-14 working days after receiving confirmation from hotels, airlines, or other suppliers.</p>
  </li>
  <li>
    <p>Refunds will be credited via the original payment method used during booking.</p>
  </li>
  <li>
    <p>Bank/payment gateway charges, visa fees, taxes, and convenience charges may be non-refundable.</p>
  </li>
</ul>

<h2>No Refund Situations</h2>

<h3><i>No refund shall be provided in the following cases:</i></h3>

<ul>
  <li>
    <p>No-show at the destination, hotel, airport, or activity</p>
  </li>
  <li>
    <p>Early check-out from hotel</p>
  </li>
  <li>
    <p>Unused services included in the package</p>
  </li>
  <li>
    <p>Last-minute cancellations during peak travel periods</p>
  </li>
  <li>
    <p>Visa rejection (unless specifically mentioned otherwise)</p>
  </li>
</ul>

<h2>Natural Events & Force Majeure</h2>
<h3><i>Unlock Destinations shall not be held responsible for cancellations, delays, or changes caused by:</i></h3>

<ul>
  <li>
    <p>Natural disasters</p>
  </li>
  <li>
    <p>Weather conditions</p>
  </li>
  <li>
    <p>Political unrest</p>
  </li>
  <li>
    <p>Pandemic restrictions</p>
  </li>
  <li>
    <p>Airline operational issues</p>
  </li>
  <li>
    <p>Government regulations or force majeure events</p>
  </li>
</ul>



  <p class="footer-note">
    Refunds in such cases will depend entirely on the policies of airlines, hotels, and vendors.
  </p>

<h2>Contact Us</h2>
  <div class="contact-box">
    <p><strong>Phone Number:</strong> +91 8766234500</p>
    <p><strong>Email:</strong> Info@unlockdestinations.in</p>
  </div>

</div>

   </div> 
    </div>
    </section>
            

    </div>
  )
}
